import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const passedUser = location.state?.user;
  const [status, setStatus] = useState(passedUser ? (passedUser.is_admin ? "ok" : "denied") : null);
  const [user, setUser] = useState(passedUser || null);

  useEffect(() => {
    if (passedUser) {
      if (!passedUser.is_admin) navigate("/login", { replace: true, state: { denied: true } });
      return;
    }
    let mounted = true;
    api
      .get("/auth/me")
      .then((res) => {
        if (!mounted) return;
        setUser(res.data);
        if (res.data.is_admin) {
          setStatus("ok");
        } else {
          setStatus("denied");
          navigate("/login", { replace: true, state: { denied: true } });
        }
      })
      .catch(() => {
        if (!mounted) return;
        setStatus("no");
        navigate("/login", { replace: true });
      });
    return () => {
      mounted = false;
    };
  }, [navigate, passedUser]);

  if (status !== "ok") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-charcoal text-slate">
        <Loader2 className="animate-spin text-crimson-bright" size={32} />
      </div>
    );
  }

  return typeof children === "function" ? children(user) : children;
}
